import React from "react";
import roomImage from "../assets/room.jpg";
import name from "../assets/name.png";

const Intro: React.FC = () => {
  return (
    <section
      id="intro"
      className="relative bg-cover bg-center bg-no-repeat flex items-center justify-center text-white py-10 px-6"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.8) 16.67%, rgba(0, 0, 0, 0.4) 50%, transparent 66.67%), url(${roomImage})`,
        backgroundPosition: "right center",
        backgroundSize: "cover",
      }}
    >
      {<div className="absolute inset-0 bg-black opacity-50"></div>}
      {/* Content */}
      <div className="relative z-10 text-center max-w-4xl mx-auto">
        <div className="flex flex-col items-center mx-auto mb-6">
          <img src={name} alt="Name" className="h-24" />
        </div>
        <p className="text-lg md:text-2xl mb-8">
          Professional Handyperson and Residential Remodeling Services
        </p>
        <p className="text-md md:text-lg mb-8 leading-relaxed">
          I'm John Hayden, and my team and I are dedicated to delivering
          quality home services at a fair price, with integrity behind every
          job. With years of experience in the industry, we handle everything
          from minor repairs to major renovations. We're proud to serve
          Johnson County and the surrounding area, and we look forward to
          helping you make your house feel more like home.
        </p>
        <a
          href="#services"
          className="inline-block bg-[#1E3A8A] text-white px-6 py-3 rounded-lg text-lg font-semibold shadow-lg hover:bg-[#3B82F6] transition duration-300"
        >
          Explore Our Services
        </a>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-br from-[#1E3A8A] to-transparent opacity-50 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-48 h-48 bg-gradient-to-tl from-[#1E3A8A] to-transparent opacity-50 rounded-full blur-3xl"></div>
    </section>
  );
};

export default Intro;
